<template>
    <b-card>
        <div v-if="isLoading" class="text-center my-5">
            <b-spinner variant="primary" label="Sending mail..."></b-spinner>
            <h4 class="mt-3">{{ $t('Sending Mail...') }}</h4>
        </div>
        <div v-else>

            <b-row class="mb-2">
                <b-col cols="12">
                    <b-form-group :label="$t('Please select the people to send emails to')" label-for="templatetitle">
                        <multiple-member-picker v-model="selectedPeopleToSend" :initial-selections="initialRecipients"
                            @selectionChanged="handleRecipientChange" />
                    </b-form-group>

                </b-col>
            </b-row>

            <b-row class="mb-2">
                <b-col cols="12">
                    <b-form-group :label="$t('Please select mail template')" label-for="templatetitle">
                        <p>
                            <small>
                                {{ $t("If you don't have any template, you can create new one in") }}
                                <router-link to="/settings">
                                    {{ $t("Settings Page") }}
                                </router-link>
                            </small>
                        </p>
                        <mail-template-selector v-if="categories" 
                            @selectionChanged="selectionChanged" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12">
                    <b-form-group :label="$t('Mail Title')" label-for="templatetitle">
                        <b-form-input v-model="selectedTemplate.templatetitle" name="mailtitle"
                            :placeholder="$t('Mail Title')" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-form>
                <b-col cols="12">
                    <b-form-group label="" label-for="bio-area">
                        <quill-editor v-model="selectedTemplate.template_content" height="300" :options="snowOption"
                            @change="onEditorChange($event)" />
                    </b-form-group>
                </b-col>
                <b-row>
                    <b-col cols="6">
                        <b-button v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" class="mt-1 w-100"
                            :disabled="isLoading" variant="outline-secondary" @click.prevent="resetForm">
                            {{ $t("Reset") }}
                        </b-button>
                    </b-col>
                    <b-col cols="6" class="d-flex justify-content-end">
                        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mt-1 w-100"
                            :disabled="!selectedPeopleToSend.length || selectedTemplate.template_content == null || selectedTemplate.template_content == ''"
                            @click.prevent="sendInformation">
                            {{ $t("Send") }}
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </div>
    </b-card>
</template>

<script>
import {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BBadge,
    BSpinner,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { quillEditor } from "vue-quill-editor";
import { encrypt } from "@core/utils/crypto"
import axios from "@axios";
import ToastificationContent from "../../@core/components/toastification/ToastificationContent.vue";
import MailTemplateSelector from "../settings/component/TemplateSelector.vue"
import MultipleMemberPicker from "../members/component/MultipleMemberPicker.vue";


export default {
    components: {
        BButton,
        BForm,
        BFormGroup,
        BFormInput,
        BRow,
        BCol,
        BCard,
        vSelect,
        quillEditor,
        BBadge,
        MailTemplateSelector,
        MultipleMemberPicker,
        ToastificationContent,
        BSpinner,
    },
    directives: {
        Ripple,
    },
    props: {
        initialRecipients: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            snowOption: {
                theme: "snow",
            },
            emailSettings: {},
            isLoading: false,
            selectedTemplate: {
                templatetitle: "",
                template_content: "",
            },
            selectedBaseMail: null,
            categories: null,
            selectedPeopleToSend: [],

        };
    },
    created() {
        this.fetchMailTemplates();
        this.fetchSettings();
        this.selectedPeopleToSend = [...this.initialRecipients];
    },
    methods: {
        handleRecipientChange(recipients) {
            this.selectedPeopleToSend = recipients;
        },

        selectionChanged(value) {
            this.selectedBaseMail = value;
            const contents = value.ClientMailTemplates;
            if (contents.length > 0) {
                this.selectedTemplate = contents[0];
            } else {
                this.selectedTemplate = {
                    templatetitle: "",
                    template_content: "",
                };
            }
        },

        fetchMailTemplates() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/admin/f/getmailtemplates")
                    .then((response) => {
                        const data = response.data;
                        this.categories = data.data;
                        this.selected = this.categories[0];
                        resolve();
                    })
                    .catch((error) => reject(error));
            });
        },
        fetchSettings() {
            return new Promise((resolve, reject) => {
                axios
                    .get("/admin/f/settings")
                    .then((response) => {
                        const data = response.data;
                        this.emailSettings = JSON.parse(data.data.emailsettings);
                        resolve();
                    })
                    .catch((error) => reject(error));
            });
        },

        sendInformation() {
            if (!this.selectedPeopleToSend.length) {
                this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                        title: "Please select at least one recipient",
                        icon: "AlertCircleIcon",
                        variant: "warning",
                    },
                });
                return;
            }
            this.isLoading = true;
            const toEmails = this.selectedPeopleToSend.map(user => user.email);
            const emailData = encrypt({
                email: {
                    to: toEmails,
                    from: this.emailSettings.from_mail,
                    subject: this.selectedTemplate.templatetitle || "No Subject",
                    text: this.selectedTemplate.template_content,
                    html: '',
                },
                smtp: {
                    host: this.emailSettings.smtp_host,
                    port: this.emailSettings.smtp_port,
                    secure: this.emailSettings.isSecured ? true : false,
                    auth: {
                        user: this.emailSettings.smtp_username,
                        pass: this.emailSettings.smtp_password
                    }
                }
            });

            this.isLoading = true;

            axios({
                method: "post",
                url: `/send-email/send-encrypted`,
                data: { "payload": emailData },

            })
                .then((response) => {
                    this.$toast({
                        component: ToastificationContent,
                        position: "top-right",
                        props: {
                            title: "Email sent successfully",
                            icon: "CheckCircleIcon",
                            variant: "success",
                        },
                    });
                    this.isLoading = false;

                    // Reset form if needed
                    this.selectedPeopleToSend = [];
                    this.selectedTemplate = {
                        templatetitle: "",
                        template_content: "",
                    };
                    this.isLoading = false;
                })
                .catch((error) => {
                    this.$toast({
                        component: ToastificationContent,
                        position: "top-right",
                        props: {
                            title: "Error sending email",
                            icon: "AlertOctagonIcon",
                            variant: "danger",
                        },
                    });
                    this.isLoading = false;
                    console.error("Email sending error:", error);
                });
        },

        resetForm() {
            this.selectedTemplate = {
                templatetitle: "",
                template_content: "",
            };
            this.selectedPeopleToSend = [];
        },

        onEditorChange({ html, text }) {
            if (this.selectedTemplate != null) {
                this.selectedTemplate.template_content = text;
            }
        },

    },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";

.ql-editor {
    min-height: 400px;
}
</style>